import { render } from "./SubmitPrepaymentDialog.vue?vue&type=template&id=97195d8a&scoped=true&ts=true"
import script from "./SubmitPrepaymentDialog.vue?vue&type=script&lang=ts"
export * from "./SubmitPrepaymentDialog.vue?vue&type=script&lang=ts"

import "./SubmitPrepaymentDialog.vue?vue&type=style&index=0&id=97195d8a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97195d8a"]])

export default __exports__